import { makeStyles } from "$components/mui-styles";
import { Box } from "@material-ui/core";
import classNames from "classnames";
import React from "react";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    flexWrap: "wrap",
    columnGap: theme.spacing(4),
    rowGap: theme.spacing(0.5),
    // Match the card body's responsive padding (8px xs / 16px sm+); the top is
    // owned by the wrapper that spaces the footer from the body.
    paddingTop: 0,
    paddingLeft: theme.spacing(1),
    paddingRight: theme.spacing(1),
    paddingBottom: theme.spacing(1),
    [theme.breakpoints.up("sm")]: {
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2),
      paddingBottom: theme.spacing(2),
    },
  },
}));

export type CardFooterProps = {
  children: React.ReactNode;
  /** Escape hatch for one-off styling, e.g. a status background. */
  className?: string;
};

/** Footer row for a card — lays out CardFooterItems with consistent spacing. */
const CardFooter = ({ children, className }: CardFooterProps) => {
  const classes = useStyles();
  return <Box className={classNames(classes.root, className)}>{children}</Box>;
};

export default CardFooter;
